import { apiUrl } from "@/lib/api";

// Facebook login is a full-page redirect that comes back to /auth/social with
// a login token in the URL. Anything that lands there with a token would be
// stored, so a link carrying somebody else's token signed the visitor into
// that account (RT-X05). The start leaves a random nonce in this browser, the
// backend carries it through Facebook in its signed state, and the landing
// accepts the token only when the nonce matches.
//
// localStorage rather than sessionStorage: it's where the login token itself
// has to go, so it adds no new way for login to fail, and it survives a
// Meta in-app browser handing the page to a new tab.
const KEY = "sift_oauth_nonce";

function randomNonce() {
  const bytes = new Uint8Array(24);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function facebookStartUrl(nextPath) {
  let nonce = "";
  try {
    nonce = randomNonce();
    window.localStorage.setItem(KEY, nonce);
  } catch { /* no storage: the landing will refuse, as it would the token */ }
  const next = encodeURIComponent(nextPath);
  return apiUrl(`/api/accounts/oauth/facebook/start/?next=${next}&nonce=${nonce}`);
}

// True when the nonce that came back is the one this browser set. One use.
export function takeOAuthNonce(returned) {
  let stored = null;
  try {
    stored = window.localStorage.getItem(KEY);
    window.localStorage.removeItem(KEY);
  } catch { /* fall through: no match */ }
  return Boolean(returned) && returned === stored;
}
